<app-auth-layout>
  <router-outlet></router-outlet>
</app-auth-layout>
